// extracted by css-extract-rspack-plugin
export default {"main":"vymDU","resizing":"tVLfX"};